import _ from 'lodash';
import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { AccountInfoService } from './services/account-info-service';
import { SiteRegion } from './enums';

export const accountInfoModule = (bind: interfaces.Bind) => {
    bind(AccountInfoService).toConstantValue({
        getModelData: () => ({
            site_region: _.get(window, 'zPREFACE.accountInfo.site_region', SiteRegion.CN),
        }),
    });
};
